import { render, staticRenderFns } from "./ChatZoomImage.vue?vue&type=template&id=3c7c1482"
import script from "./ChatZoomImage.vue?vue&type=script&lang=js"
export * from "./ChatZoomImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports